var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": _vm.user.superAdmin || _vm.arrayIntersection(['factoryLeader', 'deliveryLeader', 'deliveryAssist'], _vm.user.simpleRole).length > 0 ? 850 : 400
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("运输单")])]), _c('div', {
    staticClass: "menu-panel"
  }, [_c('div', {
    class: {
      'menu-item': true,
      'menu-selected': _vm.selectedMenuItem === 0
    }
  }, [_c('h4', [_vm._v("客户")]), _c('h3', [_vm._v(_vm._s(_vm.salesOrder ? _vm.salesOrder.customer.name : ""))]), _c('h4', [_vm._v("产品")]), _c('h2', [_vm._v(" " + _vm._s(_vm.salesOrder && _vm.salesOrder.material && _vm.salesOrder.material.name) + " ")]), _c('h4', [_vm._v("数量（吨）")]), _c('h2', [_vm._v(_vm._s(_vm.salesOrder && _vm.salesOrder.volPlan))]), _c('h4', [_vm._v("需求时间")]), _c('h2', [_vm._v(_vm._s(_vm.salesOrder && _vm.convertTimeDisplay(_vm.salesOrder.planArrivedAt)))])]), _c('div', {
    class: {
      'menu-item': true,
      'menu-selected': _vm.selectedMenuItem === 'vehicle'
    },
    on: {
      "click": _vm.selectVehicleMenuMethod
    }
  }, [_c('h4', [_vm._v("车牌")]), _c('div', {
    staticClass: "plate selected"
  }, [_vm._v(" " + _vm._s(_vm.selectedVehicle && _vm.selectedVehicle.plate || _vm.delivery && _vm.delivery.vehicle && _vm.delivery.vehicle.plate) + " ")]), _c('h4', [_vm._v("仓位容积（吨）")]), _c('div', {
    staticClass: "storageSection-wrap"
  }, _vm._l(_vm.convertStorageSection(_vm.selectedVehicle), function (v, index) {
    return _c('h3', {
      key: index,
      staticStyle: {
        "display": "inline",
        "margin-right": "12px"
      }
    }, [_vm._v(_vm._s(v))]);
  }), 0)]), _c('div', {
    class: {
      'menu-item': true,
      'menu-selected': _vm.selectedMenuItem === 'driver'
    },
    on: {
      "click": _vm.selectDriverMenuMethod
    }
  }, [_c('h4', [_vm._v("司机")]), _c('h3', [_vm._v(_vm._s(_vm.selectedDriver ? _vm.selectedDriver.map(function (e) {
    return e.name;
  }).join(", ") : "-"))])]), _c('div', {
    class: {
      'menu-item': true,
      'menu-selected': _vm.selectedMenuItem === 'schedule'
    },
    on: {
      "click": function ($event) {
        _vm.selectedMenuItem = 'schedule';
      }
    }
  }, [_c('h4', [_vm._v("出发时间（计划）")]), _c('h3', [_vm._v(" " + _vm._s(_vm.convertTimeDisplay(_vm.updateContent.departAtPlan || _vm.delivery && _vm.delivery.departAtPlan)) + " ")])])]), _vm.user.superAdmin || _vm.arrayIntersection(['factoryLeader', 'deliveryLeader', 'deliveryAssist'], _vm.user.simpleRole).length > 0 ? _c('div', {
    staticClass: "info-panel"
  }, [_vm.selectedMenuItem === 'vehicle' ? _c('div', [_c('h4', [_vm._v("更换车辆（双击快速更换）")]), _vm.vehicleList.length !== 0 ? _c('div', {
    staticClass: "info-box vehicle-list"
  }, _vm._l(_vm.vehicleList, function (v) {
    return _c('div', {
      key: v._id,
      on: {
        "click": function ($event) {
          return _vm.selectVehicle(v);
        },
        "dblclick": _vm.confirmClicked
      }
    }, [_c('div', {
      class: {
        plate: true,
        selected: _vm.selectedVehicle && _vm.selectedVehicle._id === v._id
      },
      staticStyle: {
        "margin": "8px"
      }
    }, [_c('span', [_vm._v(_vm._s(v.plate.slice(0, 2)) + " " + _vm._s(v.plate.slice(2)))])])]);
  }), 0) : _c('Alert', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("目前还没有录入车辆，请前往【车辆信息】页面录入。")]), _c('h4', [_vm._v("车辆信息")]), _c('div', {
    staticClass: "info-box"
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('h4', [_vm._v("车牌")]), _c('h3', [_vm._v(_vm._s(_vm.selectedVehicle && _vm.selectedVehicle.plate || "-"))])]), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('h4', [_vm._v("名字")]), _c('h3', [_vm._v(_vm._s(_vm.selectedVehicle && _vm.selectedVehicle.name || "-"))])]), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('h4', [_vm._v("仓位容积（吨）")]), _c('h3', [_vm._v(_vm._s(_vm.selectedVehicle && _vm.selectedVehicle.capacity || "-"))])]), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('h4', [_vm._v("默认司机")]), _c('h3', [_vm._v(" " + _vm._s(_vm.selectedVehicle && _vm.selectedVehicle.defaultDriver.name || "-") + " ")])])], 1), _c('Row', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('h4', [_vm._v("仓位容积（吨）")]), _vm._l(_vm.convertStorageSection(_vm.selectedVehicle), function (v, index) {
    return _c('h3', {
      key: index,
      staticStyle: {
        "float": "left",
        "margin-right": "12px"
      }
    }, [_vm._v(_vm._s(v))]);
  })], 2), _c('h4', {
    staticStyle: {
      "margin": "18px 0 12px 0"
    }
  }, [_vm._v("运输记录（最近5条）")]), _c('Table', {
    attrs: {
      "columns": _vm.vehicleHistColumns,
      "data": _vm.vehicleHistTableData,
      "size": "small"
    }
  })], 1)], 1) : _vm._e(), _vm.selectedMenuItem === 'driver' ? _c('div', [_c('h4', [_vm._v("更换司机")]), _vm.driverList.length !== 0 ? _c('div', {
    staticClass: "info-box vehicle-list"
  }, _vm._l(_vm.driverList, function (driver) {
    return _c('div', {
      key: driver._id,
      on: {
        "click": function ($event) {
          return _vm.selectDriver(driver);
        }
      }
    }, [_c('div', {
      class: {
        plate: true,
        selected: _vm.selectedDriver.map(function (e) {
          return e._id;
        }).includes(driver._id)
      },
      staticStyle: {
        "margin": "8px"
      }
    }, [_c('span', [_vm._v(_vm._s(driver.name))])])]);
  }), 0) : _c('Alert', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("目前还没有录入司机，请前往【用户和权限】页面录入。")]), _c('h4', {
    staticStyle: {
      "margin": "18px 0 12px 0"
    }
  }, [_vm._v("运输记录（最近5条）")]), _c('Table', {
    attrs: {
      "columns": _vm.vehicleHistColumns,
      "data": _vm.vehicleHistTableData,
      "size": "small"
    }
  })], 1) : _vm._e(), _vm.selectedMenuItem === 'schedule' ? _c('div', [_c('h4', [_vm._v("出发时间（计划）")]), _c('div', {
    staticStyle: {
      "width": "180px",
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "150px",
      "margin-right": "16px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: _vm.selected.departAtPlanDate,
      callback: function ($$v) {
        _vm.$set(_vm.selected, "departAtPlanDate", $$v);
      },
      expression: "selected.departAtPlanDate"
    }
  })], 1), _c('div', {
    staticStyle: {
      "width": "150px",
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_c('TimePicker', {
    staticStyle: {
      "width": "112px"
    },
    attrs: {
      "format": "HH:mm",
      "placeholder": "选择时间"
    },
    model: {
      value: _vm.selected.departAtPlanTime,
      callback: function ($$v) {
        _vm.$set(_vm.selected, "departAtPlanTime", $$v);
      },
      expression: "selected.departAtPlanTime"
    }
  })], 1), _c('div', {
    staticClass: "date-option-cell-list",
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    }
  }, _vm._l(_vm.dateOption, function (d) {
    return _c('div', {
      key: d.name,
      class: {
        'date-option-cell': true,
        'date-selected': d.addDates === _vm.dateOptionValue
      },
      on: {
        "click": function ($event) {
          return _vm.departAtPlanBtnClick(d.addDates);
        }
      }
    }, [_vm._v(_vm._s(d.name))]);
  }), 0), _c('div', {
    staticClass: "date-option-cell-list"
  }, _vm._l(_vm.timeOption, function (t) {
    return _c('div', {
      key: t.name,
      class: {
        'date-option-cell': true,
        'date-selected': t.time === _vm.selected.departAtPlanTime
      },
      on: {
        "click": function ($event) {
          _vm.selected.departAtPlanTime = t.time;
        }
      }
    }, [_vm._v(_vm._s(t.time))]);
  }), 0)]) : _vm._e()]) : _vm._e(), JSON.stringify(_vm.updateContent) !== '{}' ? _c('div', {
    staticClass: "footer"
  }, [_c('Button', {
    staticStyle: {
      "width": "150px",
      "margin-left": "12px"
    },
    attrs: {
      "disabled": false,
      "type": "primary",
      "size": "large",
      "loading": _vm.confirmBtnLoading
    },
    on: {
      "click": _vm.confirmClicked
    }
  }, [_vm._v("保存")])], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }